import React from 'react'
import { View, Text, Avatar, Touchable } from '@/components'
import { createStyles } from '@codeleap/styles'
import { textVariant } from '@/config'
import { MentionUser } from '@packages/chat'

type MentionSuggestionsListProps = {
  suggestions: MentionUser[]
  onSelect: (user: MentionUser) => void
  visible: boolean
}

export const MentionSuggestionsList = ({
  suggestions,
  onSelect,
  visible,
}: MentionSuggestionsListProps) => {
  if (!visible || suggestions.length === 0) return null

  return (
    <View style={styles.container}>
      {suggestions.map((user) => (
        <Touchable
          key={user.id}
          style={styles.mentionItem}
          onPress={() => onSelect(user)}
          debugName={`EditMentionSuggestion:${user.id}`}
        >
          <Avatar
            debugName='EditMentionSuggestion:Avatar'
            image={user.image as any}
            name={user.name}
            style={['small']}
          />
          <View style={styles.mentionInfo}>
            <Text style={styles.mentionName}>{user.name}</Text>
          </View>
        </Touchable>
      ))}
    </View>
  )
}

const styles = createStyles(t => ({
  container: {
    position: 'absolute',
    bottom: '100%',
    left: 0,
    right: 0,
    backgroundColor: t.colors.bgDefault,
    borderRadius: t.radius.regular,
    boxShadow: `0 -2px 8px ${t.colors.headerShadow || t.baseColors.neutralBlackTransparent50}`,
    maxHeight: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: 10,
    flexDirection: 'column',
    display: 'flex',
  },
  mentionItem: {
    ...t.presets.row,
    ...t.spacing.gap(1),
    ...t.spacing.paddingHorizontal(2),
    ...t.spacing.paddingVertical(1),
    ...t.presets.alignCenter,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: t.baseColors.neutralSolid100,
    },
  },
  mentionInfo: {
    ...t.presets.flex,
    ...t.presets.column,
  },
  mentionName: {
    ...textVariant('p3'),
    fontWeight: '500',
    color: t.colors.textHeadingHighlighted,
  },
}))
